import debounce from '../../../../../core/utils/src/debounce';
var DrawersController = /** @class */ (function () {
    function DrawersController() {
        var _this = this;
        this.drawers = [];
        this.drawersRegistrationListener = null;
        this.scheduleUpdate = debounce(function () {
            var _a, _b;
            (_b = (_a = _this).drawersRegistrationListener) === null || _b === void 0 ? void 0 : _b.call(_a, _this.drawers);
        }, 0);
        this.registerDrawer = function (config) {
            _this.drawers = _this.drawers.concat(config);
            _this.scheduleUpdate();
        };
        this.onDrawersRegistered = function (listener) {
            if (_this.drawersRegistrationListener !== null) {
                console.warn('[AwsUi] [runtime drawers] multiple app layout instances detected');
            }
            _this.drawersRegistrationListener = listener;
            _this.scheduleUpdate();
            return function () {
                _this.drawersRegistrationListener = null;
            };
        };
        this.clearRegisteredDrawers = function () {
            _this.drawers = [];
        };
    }
    DrawersController.prototype.installPublic = function (api) {
        if (api === void 0) { api = {}; }
        var _a;
        api.registerDrawer = (_a = api.registerDrawer, (_a !== null && _a !== void 0 ? _a : this.registerDrawer));
        return api;
    };
    DrawersController.prototype.installInternal = function (internalApi) {
        if (internalApi === void 0) { internalApi = {}; }
        var _a, _b;
        internalApi.clearRegisteredDrawers = (_a = internalApi.clearRegisteredDrawers, (_a !== null && _a !== void 0 ? _a : this.clearRegisteredDrawers));
        internalApi.onDrawersRegistered = (_b = internalApi.onDrawersRegistered, (_b !== null && _b !== void 0 ? _b : this.onDrawersRegistered));
        return internalApi;
    };
    return DrawersController;
}());
export { DrawersController };
//# sourceMappingURL=drawers.js.map